exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".partial--spinner--cont .partial--spinner--background{width:100%;height:100%;position:fixed;top:0;left:0;background-color:#fff;opacity:.3;z-index:19999}.partial--spinner--cont .partial--spinner:after{content:\"\";box-sizing:border-box;position:fixed;top:calc(50% - 20px);left:calc(50% - 20px);width:40px;height:40px;margin-top:-10px;margin-left:-10px;border-radius:50%;border:4px solid #fff;border-top-color:#eb0029;animation:spinner 1s linear infinite;z-index:20000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d7b3b5a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./web/webroot/_ui/responsive/common/js/src/components/partialspinner/partialspinner.scss
// module id = 799
// module chunks = 11